var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBulCircleUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "white",
    stroke: "#646782"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.88125 10L8 5.91083L12.1187 9.99363L13 9.09554L8 4L3 9.09554L3.88125 10Z",
    fill: "#646782"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBulCircleUp);
export default __webpack_public_path__ + "static/media/ico-bul-circle-up.8dd1d66a39e86ea69b61f7d347836101.svg";
export { ForwardRef as ReactComponent };